const RoomForm = () => import(/* webpackChunkName: "page-room-form" */ '@/components/pages/room/Index.vue')
const RoomRegulars = () => import(/* webpackChunkName: "page-room-regulars" */ '@/components/pages/room/Regulars.vue')
const RoomParkings = () => import(/* webpackChunkName: "page-room-parkings" */ '@/components/pages/room/Parkings.vue')
const RoomWarranties = () =>
  import(/* webpackChunkName: "page-room-warranties" */ '@/components/pages/room/Warranties.vue')
const RoomTransactions = () =>
  import(/* webpackChunkName: "page-room-transactions" */ '@/components/pages/room/Transactions.vue')
const RoomEquipments = () =>
  import(/* webpackChunkName: "page-room-equipments" */ '@/components/pages/room/Equipments.vue')
const RoomImages = () => import(/* webpackChunkName: "page-room-images" */ '@/components/pages/room/Images.vue')
const RoomAddImages = () =>
  import(/* webpackChunkName: "page-room-add-images" */ '@/components/pages/room/AddImages.vue')
const RoomCatchCommons = () =>
  import(/* webpackChunkName: "page-room-catch-commons" */ '@/components/pages/room/CatchCommons.vue')
const RoomCatchShops = () =>
  import(/* webpackChunkName: "page-room-catch-shops" */ '@/components/pages/room/CatchShops.vue')
const RoomMemos = () => import(/* webpackChunkName: "page-room-memos" */ '@/components/pages/room/Memos.vue')
const RoomBruno = () => import(/* webpackChunkName: "page-room-bruno" */ '@/components/pages/room/Bruno.vue')
const RoomKiwami = () => import(/* webpackChunkName: "page-room-kiwami" */ '@/components/pages/room/Kiwami.vue')
const RoomItandibb = () => import(/* webpackChunkName: "page-room-itandibb" */ '@/components/pages/room/Itandibb.vue')

export default [
  // 新規作成
  {
    path: 'new/building/:buildingId/room',
    component: RoomForm,
    redirect: {
      name: 'room-regulars',
    },
    children: [
      {
        path: 'regulars',
        component: RoomRegulars,
        name: 'room-regulars',
        meta: {
          title: '部屋 基本情報',
          type: 'new',
          auth: null,
        },
      },
      {
        path: 'parkings',
        component: RoomParkings,
        name: 'room-parkings',
        meta: {
          title: '部屋 駐車場情報',
          type: 'new',
          auth: null,
        },
      },
      {
        path: 'warranties',
        component: RoomWarranties,
        name: 'room-warranties',
        meta: {
          title: '部屋 保証・保険',
          type: 'new',
          auth: null,
        },
      },
      {
        path: 'transactions',
        component: RoomTransactions,
        name: 'room-transactions',
        meta: {
          title: '部屋 取引管理',
          type: 'new',
          auth: null,
        },
      },
      {
        path: 'equipments',
        component: RoomEquipments,
        name: 'room-equipments',
        meta: {
          title: '部屋 間取り・設備・動画',
          type: 'new',
          auth: null,
        },
      },
      {
        path: 'images',
        component: RoomImages,
        name: 'room-images',
        meta: {
          title: '部屋 画像・パノラマ',
          type: 'new',
          auth: null,
        },
      },
      {
        path: 'add-images',
        component: RoomAddImages,
        name: 'room-add-images',
        meta: {
          title: '部屋 追加画像',
          type: 'new',
          auth: ['can_use_bc_option_images'],
        },
      },
      {
        path: 'catch-commons',
        component: RoomCatchCommons,
        name: 'room-catch-commons',
        meta: {
          title: '部屋 キャッチ・備考（共通）',
          type: 'new',
          auth: null,
        },
      },
      {
        path: 'catch-shops',
        component: RoomCatchShops,
        name: 'room-catch-shops',
        meta: {
          title: '部屋 キャッチ・備考（各店）',
          type: 'new',
          auth: ['can_use_original_catchcopy'],
        },
      },
      {
        path: 'memos',
        component: RoomMemos,
        name: 'room-memos',
        meta: {
          title: '部屋 部屋メモ',
          type: 'new',
          auth: null,
        },
      },
      {
        path: 'bruno',
        component: RoomBruno,
        name: 'room-bruno',
        meta: {
          title: '部屋 BRUNO',
          type: 'new',
          auth: ['f_buruno_tab'],
        },
      },
      {
        path: 'kiwami',
        component: RoomKiwami,
        name: 'room-kiwami',
        meta: {
          title: '部屋 極kiwami',
          type: 'new',
          auth: ['f_kiwami_tab'],
        },
      },
      {
        path: 'itandibb',
        component: RoomItandibb,
        name: 'room-itandibb',
        meta: {
          title: '部屋 イタンジBB',
          type: 'new',
          auth: ['f_itandibb_tab'],
        },
      },
    ],
  },
  // 編集
  {
    path: '/edit/room/:roomId',
    component: RoomForm,
    redirect: {
      name: 'room-regulars-edit',
    },
    children: [
      {
        path: 'regulars',
        component: RoomRegulars,
        name: 'room-regulars-edit',
        meta: {
          title: '部屋 基本情報',
          type: 'edit',
          auth: null,
        },
      },
      {
        path: 'parkings',
        component: RoomParkings,
        name: 'room-parkings-edit',
        meta: {
          title: '部屋 駐車場情報',
          type: 'edit',
          auth: null,
        },
      },
      {
        path: 'warranties',
        component: RoomWarranties,
        name: 'room-warranties-edit',
        meta: {
          title: '部屋 保証・保険',
          type: 'edit',
          auth: null,
        },
      },
      {
        path: 'transactions',
        component: RoomTransactions,
        name: 'room-transactions-edit',
        meta: {
          title: '部屋 取引管理',
          type: 'edit',
          auth: null,
        },
      },
      {
        path: 'equipments',
        component: RoomEquipments,
        name: 'room-equipments-edit',
        meta: {
          title: '部屋 間取り・設備・動画',
          type: 'edit',
          auth: null,
        },
      },
      {
        path: 'images',
        component: RoomImages,
        name: 'room-images-edit',
        meta: {
          title: '部屋 画像・パノラマ',
          type: 'edit',
          auth: null,
        },
      },
      {
        path: 'add-images',
        component: RoomAddImages,
        name: 'room-add-images-edit',
        meta: {
          title: '部屋 追加画像',
          type: 'edit',
          auth: ['can_use_bc_option_images'],
        },
      },
      {
        path: 'catch-commons',
        component: RoomCatchCommons,
        name: 'room-catch-commons-edit',
        meta: {
          title: '部屋 キャッチ・備考（共通）',
          type: 'edit',
          auth: null,
        },
      },
      {
        path: 'catch-shops',
        component: RoomCatchShops,
        name: 'room-catch-shops-edit',
        meta: {
          title: '部屋 キャッチ・備考（各店）',
          type: 'edit',
          auth: ['can_use_original_catchcopy'],
        },
      },
      {
        path: 'memos',
        component: RoomMemos,
        name: 'room-memos-edit',
        meta: {
          title: '部屋 部屋メモ',
          type: 'edit',
          auth: null,
        },
      },
      {
        path: 'bruno',
        component: RoomBruno,
        name: 'room-bruno-edit',
        meta: {
          title: '部屋 BRUNO',
          type: 'edit',
          auth: ['f_buruno_tab'],
        },
      },
      {
        path: 'kiwami',
        component: RoomKiwami,
        name: 'room-kiwami-edit',
        meta: {
          title: '部屋 極kiwami',
          type: 'edit',
          auth: ['f_kiwami_tab'],
        },
      },
      {
        path: 'itandibb',
        component: RoomItandibb,
        name: 'room-itandibb-edit',
        meta: {
          title: '部屋 イタンジBB',
          type: 'edit',
          auth: ['f_itandibb_tab'],
        },
      },
    ],
  },
  // コピー
  {
    path: '/copy/building/:buildingId/room/:roomId/type/:typeId',
    component: RoomForm,
    redirect: {
      name: 'room-regulars-copy',
    },
    children: [
      {
        path: 'regulars',
        component: RoomRegulars,
        name: 'room-regulars-copy',
        meta: {
          title: '部屋 基本情報',
          type: 'copy',
          auth: null,
        },
      },
      {
        path: 'parkings',
        component: RoomParkings,
        name: 'room-parkings-copy',
        meta: {
          title: '部屋 駐車場情報',
          type: 'copy',
          auth: null,
        },
      },
      {
        path: 'warranties',
        component: RoomWarranties,
        name: 'room-warranties-copy',
        meta: {
          title: '部屋 保証・保険',
          type: 'copy',
          auth: null,
        },
      },
      {
        path: 'transactions',
        component: RoomTransactions,
        name: 'room-transactions-copy',
        meta: {
          title: '部屋 取引管理',
          type: 'copy',
        },
      },
      {
        path: 'equipments',
        component: RoomEquipments,
        name: 'room-equipments-copy',
        meta: {
          title: '部屋 間取り・設備・動画',
          type: 'copy',
          auth: null,
        },
      },
      {
        path: 'images',
        component: RoomImages,
        name: 'room-images-copy',
        meta: {
          title: '部屋 画像・パノラマ',
          type: 'copy',
        },
      },
      {
        path: 'add-images',
        component: RoomAddImages,
        name: 'room-add-images-copy',
        meta: {
          title: '部屋 追加画像',
          type: 'copy',
          auth: ['can_use_bc_option_images'],
        },
      },
      {
        path: 'catch-commons',
        component: RoomCatchCommons,
        name: 'room-catch-commons-copy',
        meta: {
          title: '部屋 キャッチ・備考（共通）',
          type: 'copy',
          auth: null,
        },
      },
      {
        path: 'catch-shops',
        component: RoomCatchShops,
        name: 'room-catch-shops-copy',
        meta: {
          title: '部屋 キャッチ・備考（各店）',
          type: 'copy',
          auth: ['can_use_original_catchcopy'],
        },
      },
      {
        path: 'memos',
        component: RoomMemos,
        name: 'room-memos-copy',
        meta: {
          title: '部屋 部屋メモ',
          type: 'copy',
          auth: null,
        },
      },
      {
        path: 'bruno',
        component: RoomBruno,
        name: 'room-bruno-copy',
        meta: {
          title: '部屋 BRUNO',
          type: 'copy',
          auth: ['f_buruno_tab'],
        },
      },
      {
        path: 'kiwami',
        component: RoomKiwami,
        name: 'room-kiwami-copy',
        meta: {
          title: '部屋 極kiwami',
          type: 'copy',
          auth: ['f_kiwami_tab'],
        },
      },
      {
        path: 'itandibb',
        component: RoomItandibb,
        name: 'room-itandibb-copy',
        meta: {
          title: '部屋 イタンジBB',
          type: 'copy',
          auth: ['f_itandibb_tab'],
        },
      },
    ],
  },
]
